import React, {Component} from 'react';
import {connect} from 'react-redux';
import {changeStepWaitBlock, showWaitBlock} from "../../../Structure/actions/actionsStructure";
import {login} from "../../../AdminProtectora/actions/actionsAdmin";
import {Line} from "react-chartjs-2";
import {LazyLoadImage} from "react-lazy-load-image-component";

let showMetricas = false;
const dataChart = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'Impresiones',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: []
        },
        {
            label: 'Clics',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(31,120,203,0.4)',
            borderColor: 'rgba(31,120,203,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(31,120,203,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(31,120,203,1)',
            pointHoverBorderColor: 'rgba(31,120,203,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: []
        }
    ]
};

class GraficoLineas extends Component {

    constructor(props) {
        super(props);

        this.calcularMultipleData = this.calcularMultipleData.bind(this);
        this.calcularSingleData = this.calcularSingleData.bind(this);

    }

    calcularMultipleData() {
        showMetricas = false;
        let objMetricasTotales = {
            clics: {
                perfil: 0
            },
            impresiones: {
                perfil: 0
            }
        }

        try {
            if (this.props.multipleData && this.props.multipleData.length) {

                const infoAnimales = this.props.multipleData;
                let timeseriesAnimales = infoAnimales.map((animal) => (animal && animal.metricas && animal.metricas.timeseries) ? animal.metricas.timeseries : [])
                let metricasTotalesAnimales = infoAnimales.map((animal) => (animal && animal.metricas && animal.metricas.total) ? animal.metricas.total : [])

                let impresionesAnimales = [];
                let clicsAnimales = [];
                let labelsAnimales = [];
                let objMetricas = {};


                metricasTotalesAnimales.forEach((metrica) => {
                    objMetricasTotales.clics.perfil += metrica.clics.perfil;
                    objMetricasTotales.impresiones.perfil += metrica.impresiones.perfil;
                })


                timeseriesAnimales = [].concat.apply([], timeseriesAnimales);
                timeseriesAnimales
                    .forEach((metrica) => {

                        let dateStr = ""
                        if (metrica.fecha.length === 10) {
                            dateStr = metrica.fecha
                        } else {
                            let date = new Date(metrica.fecha).toISOString();
                            dateStr = date
                        }

                        if (objMetricas[dateStr]) {
                            objMetricas[dateStr].clics += metrica.clics.perfil
                            objMetricas[dateStr].impresiones += metrica.impresiones.perfil
                        } else {
                            objMetricas[dateStr] = {
                                clics: metrica.clics.perfil,
                                impresiones: metrica.impresiones.perfil,
                                fecha: metrica.fecha
                            }
                        }


                    });


                Object.keys(objMetricas)
                    .sort((a, b) => {
                        return new Date(a) - new Date(b);
                    })
                    .forEach((key) => {
                        let date = new Date(key).toISOString();
                        objMetricas[key].fecha = date.slice(8, 10) + "-" + date.slice(5, 7) + "-" + date.slice(0, 4);

                        labelsAnimales.push(objMetricas[key].fecha);
                        clicsAnimales.push(objMetricas[key].clics);
                        impresionesAnimales.push(objMetricas[key].impresiones);
                    })

                dataChart.labels = labelsAnimales
                dataChart.datasets[0].data = impresionesAnimales
                dataChart.datasets[1].data = clicsAnimales


                // if (labelsAnimales && impresionesAnimales && clicsAnimales
                //     && labelsAnimales.length > 0 && impresionesAnimales.length > 0 && clicsAnimales.length > 0
                //     && objMetricasTotales && (objMetricasTotales.clics > 0 || objMetricasTotales.impresiones > 0)) {
                showMetricas = true
                // }
            }

        } catch (e) {
            console.error("Metricas de animales no cargadas", e)
            showMetricas = false
        }
    }

    calcularSingleData() {

        showMetricas = false
        try {
            const timeseries = (this.props.singleData && this.props.singleData.metricas && this.props.singleData.metricas.timeseries) ? this.props.singleData.metricas.timeseries : undefined;
            if (timeseries) {

                let impresiones = []
                let clics = []
                let labels = []

                timeseries.map((metrica) => {
                    let dateStr = ""
                    if (metrica.fecha.length === 10) {
                        dateStr = metrica.fecha
                    } else {
                        let date = new Date(metrica.fecha).toISOString();
                        dateStr = date.slice(8, 10) + "-" + date.slice(5, 7) + "-" + date.slice(0, 4);
                    }
                    labels.push(dateStr)
                    clics.push(metrica.clics.perfil);
                    impresiones.push(metrica.impresiones.perfil);
                })

                // dataAnimal.labels = labels
                // dataAnimal.datasets[0].data = impresiones
                // dataAnimal.datasets[1].data = clics
                dataChart.labels = labels
                dataChart.datasets[0].data = impresiones
                dataChart.datasets[1].data = clics

                if (labels && impresiones && clics
                    && labels.length > 0 && impresiones.length > 0 && clics.length > 0) {

                    showMetricas = true
                }
            }
        } catch (e) {
            console.error("error al cargar las metricas", e)
        }
    }

    render() {
        showMetricas = false;

        if (this.props.multipleData) {
            this.calcularMultipleData();
        } else if (this.props.singleData) {
            this.calcularSingleData();
        }

        return (
            <div className="div-chart-line">
                {showMetricas &&
                <Line data={dataChart}
                      width={100}
                      height={50}
                      options={{
                          maintainAspectRatio: false
                      }}/>
                }
                {!showMetricas &&
                <LazyLoadImage threshold={150} src={process.env.CDN_URL + '/images/adoptaunanimal/metricas/image.jpg'}/>
                }
                {!showMetricas &&
                <span>
                    No hay métricas disponibles
                    <br/>
                    <span>Añade animales para poder ver sus métricas</span>
                </span>
                }
            </div>
        );
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

}

function mapStateToProps(state) {
    return {
        showHead: state.structureControl.showHead,
        showFooter: state.structureControl.showFooter,
        showWaitBlock: state.structureControl.showWaitBlock,
        stepWaitBlock: state.structureControl.stepWaitBlock,
        errorWaitBlock: state.structureControl.errorWaitBlock,
        isLogin: state.access.isLogin
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {changeWaitBlock: showWaitBlock, changeStepWaitBlock, login})(GraficoLineas)
